import { createRoute, redirect } from '@tanstack/react-router'

import { rootRoute } from '@/routes/root'
import { ensureAuthenticatedUser } from '@/utils/auth-wall'
import { Features } from '@/utils/featureFlag/features'

import { DashboardErrorComponent } from './view/dashboardErrorComponent'
import { DashboardSkeleton } from './view/dashboardSkeleton'

export const dashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/dashboard',
  beforeLoad: async ({ context, location }) => {
    await ensureAuthenticatedUser({ context, location })
    if (context.isFeatureEnabled && !context.isFeatureEnabled(Features.SHIP_V2_DASHBOARD)) {
      throw redirect({
        to: '/',
      })
    }
  },
  pendingComponent: DashboardSkeleton,
  errorComponent: DashboardErrorComponent,
}).lazy(() => import('./view/dashboard').then((d) => d.Route))
